import { T, Var, useGT } from 'gt-react';
import type { ActivityActor } from '@erp/rpc';

/**
 * "by <user>" on an audit-trail entry: the user's name, a removed user when
 * the account is gone, or System for writes with no user (hover shows where
 * the write came from).
 */
export function ActivityActorLabel({ actor }: { actor: ActivityActor }) {
  const gt = useGT();
  if (actor.userName) {
    return (
      <span className="text-xs text-muted-foreground">
        <T context="activity feed, action performed by named user">
          by <Var>{actor.userName}</Var>
        </T>
      </span>
    );
  }
  if (actor.userId) {
    return (
      <span className="text-xs text-muted-foreground">
        <T context="activity feed, action performed by a user whose account no longer exists">
          by a removed user
        </T>
      </span>
    );
  }
  const sourceTitle =
    actor.sourceType === 'workflow'
      ? gt('Changed from inside a workflow run', {
          context: 'tooltip on the System actor label',
        })
      : (actor.sourceDetail ?? undefined);
  return (
    <span className="text-xs text-muted-foreground" title={sourceTitle}>
      <T context="activity feed, action performed automatically with no user">
        by System
      </T>
    </span>
  );
}
